import React from 'react';
import { useForm } from 'react-hook-form';

import MemorySprkRecipientsItem from './SprkRecipientsItem';

interface MemorySprkRecipientsProps {
  recipients: any;
  errors: any;
  setValue: Function;
  addRecipient: Function;
  removeRecipient: Function;
};

const MemorySprkRecipients: React.FC<MemorySprkRecipientsProps> = ({ recipients, errors, setValue, addRecipient, removeRecipient }) => {
  const { register } = useForm({
    defaultValues: recipients,
  });

  return (
    <div className="memory-recipients-container inner">
      <div className="memory-recipients-header">
        <div className="page-eyebrow">
          <wa-avatar initials="4" />
          Who's it for?
        </div>
      </div>
      <div className="memory-recipients wa-stack">
        {recipients.map((recipient: any, index: number) => (
          <MemorySprkRecipientsItem
            key={recipient.id}
            index={index}
            recipient={recipient}
            register={register}
            errors={errors}
            setValue={setValue}
            removeRecipient={removeRecipient}
            showRemoveButton={recipients.length > 1}
          />
        ))}
        {errors.recipients && (
          <div className="error-message">{errors.recipients.message}</div>
        )}
        {recipients.length < 5 && (
          <wa-button onClick={() => addRecipient({ name: '', email: '', phone: '' })}>
            Add Recipient
          </wa-button>
        )}
      </div>
    </div>
  );
}

export default MemorySprkRecipients;
